'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CartImage = function (_React$Component) {
    _inherits(CartImage, _React$Component);

    function CartImage(props) {
        _classCallCheck(this, CartImage);

        var _this = _possibleConstructorReturn(this, (CartImage.__proto__ || Object.getPrototypeOf(CartImage)).call(this, props));

        _this.hideBrokenIcon = _this.hideBrokenIcon.bind(_this);
        return _this;
    }

    _createClass(CartImage, [{
        key: 'hideBrokenIcon',
        value: function hideBrokenIcon() {
            this.imgPrev.style.visibility = 'collapse';
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.imgPrev.onload = null;
            this.imgPrev.onerror = null;
            this.imgPrev = null;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                link = _props.link,
                itemName = _props.itemName,
                classNames = _props.classNames;


            return _react2.default.createElement('img', {
                src: link,
                ref: function ref(img) {
                    return _this2.imgPrev = img;
                },
                title: itemName,
                alt: itemName,
                className: classNames,
                onError: this.hideBrokenIcon
            });
        }
    }]);

    return CartImage;
}(_react2.default.Component);

exports.default = CartImage;


//////////////////
// WEBPACK FOOTER
// ./src/components/generic/image-handling/cart-image.jsx
// module id = 479
// module chunks = 0